import { CountryIso2 } from 'react-international-phone'

export const getUrlLocale = (): string => {
  if (typeof window === 'undefined') return 'en'
  else if (window.location.pathname.includes('redirect')) return 'en'
  else return window.location.pathname.split('/')[1]
}

export const getDefaultPrefix = (): CountryIso2 => {
  const locale = getUrlLocale()
  if (locale === 'en') return 'gb'
  if (locale.length === 5) {
    const localeMinimized: CountryIso2 = locale.slice(-2)
    return localeMinimized
  } else return 'gb'
}
